import React, { useEffect } from 'react';

export function OrganizationSidebar (props: {originalUrl: string}): JSX.Element {
  const [selectedTab, setSelectedTab] = React.useState<SidebarTabTitle>(getSelectedTab(props.originalUrl));
  const [error, setError] = React.useState<string | null>(null);
  const [pendingSiteRequests, setPendingSiteRequests] = React.useState<number>(0);

  useEffect(() => {
    getPendigSiteRequests();
  });

  const getPendigSiteRequests = async () => {
    const response = await fetch('/organization/api/pending_site_requests', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });
    if (response.status === 200) {
      const pendingSites = await response.json();
      setPendingSiteRequests(pendingSites.length);
    } else {
      setError('Unable to get pending site requests');
    }
  };

  return (
    <>
      {
        error && <div className='section'>
          <div className='notification is-danger'>
            {error}
          </div>
        </div>
      }
      <ul className='assessment-element-list mt-4'>
        {organizationSidebarTabs.map((tab: SidebarTab) => (
          <li
            key={tab.path}
            className={`${ selectedTab === tab.title ? 'assessment-element-selected': ''}`}
          >
            <a
              href={tab.path}
              className='is-flex is-align-items-center is-justify-content-space-between'
              onClick={() => setSelectedTab(tab.title)}
            >
              {tab.title}
              {
                tab.title === 'Pending site requests' && pendingSiteRequests > 0
                  ? <span className='pending-site-request-total'>
                    {pendingSiteRequests}
                  </span>
                  : <></>
              }
            </a>
          </li>
        ))}
      </ul>
    </>


  );
}

const getSelectedTab = (originalUrl: string) => {
  const currentPath = originalUrl;
  const selectedTab = organizationSidebarTabs.find((tab) => currentPath.startsWith(tab.path));
  if (selectedTab) {
    return selectedTab.title;
  }
  return '';
};

const organizationSidebarTabs: SidebarTab[] = [
  {path: '/organization/sites', title: 'Manage sites'},
  {path: '/organization/pending_site_requests', title: 'Pending site requests'},
  {path: '/organization/companies', title: 'Manage companies'},
  {path: '/organization/add_company', title: 'Add company'},
  {path: '/organization/manage_users', title: 'Manage users'}
];

type SidebarTab = {
  path: string;
  title: SidebarTabTitle;
};

type SidebarTabTitle = 'Manage sites' | 'Pending site requests' | 'Manage companies' | 'Add company' | 'Manage users' | '';